/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateApiKeyRequest,
  CreatedApiKey,
  ErrorEnvelope,
  ListApiKeys200Response,
  ListCompanyApiKeys200Response,
} from '../models/index';
import {
    CreateApiKeyRequestFromJSON,
    CreateApiKeyRequestToJSON,
    CreatedApiKeyFromJSON,
    CreatedApiKeyToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ListApiKeys200ResponseFromJSON,
    ListApiKeys200ResponseToJSON,
    ListCompanyApiKeys200ResponseFromJSON,
    ListCompanyApiKeys200ResponseToJSON,
} from '../models/index';

export interface CreateApiKeyOperationRequest {
    createApiKeyRequest: CreateApiKeyRequest;
}

export interface ListApiKeysRequest {
    page?: number;
    limit?: number;
}

export interface ListCompanyApiKeysRequest {
    page?: number;
    limit?: number;
}

export interface RevokeApiKeyRequest {
    apiKeyId: number;
}

/**
 * ApiKeysApi - interface
 * 
 * @export
 * @interface ApiKeysApiInterface
 */
export interface ApiKeysApiInterface {
    /**
     * Returns the plaintext key exactly once. Only a hash is stored server-side.
     * @summary Create an API key
     * @param {CreateApiKeyRequest} createApiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApiInterface
     */
    createApiKeyRaw(requestParameters: CreateApiKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedApiKey>>;

    /**
     * Returns the plaintext key exactly once. Only a hash is stored server-side.
     * Create an API key
     */
    createApiKey(requestParameters: CreateApiKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedApiKey>;

    /**
     * 
     * @summary List the current user\'s API keys
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApiInterface
     */
    listApiKeysRaw(requestParameters: ListApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListApiKeys200Response>>;

    /**
     * List the current user\'s API keys
     */
    listApiKeys(requestParameters: ListApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListApiKeys200Response>;

    /**
     * 
     * @summary List all API keys in the company (admin/owner only)
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApiInterface
     */
    listCompanyApiKeysRaw(requestParameters: ListCompanyApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCompanyApiKeys200Response>>;

    /**
     * List all API keys in the company (admin/owner only)
     */
    listCompanyApiKeys(requestParameters: ListCompanyApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCompanyApiKeys200Response>;

    /**
     * Users revoke their own keys; company admins/owners can revoke any key in the company.
     * @summary Revoke an API key
     * @param {number} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApiInterface
     */
    revokeApiKeyRaw(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Users revoke their own keys; company admins/owners can revoke any key in the company.
     * Revoke an API key
     */
    revokeApiKey(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ApiKeysApi extends runtime.BaseAPI implements ApiKeysApiInterface {

    /**
     * Returns the plaintext key exactly once. Only a hash is stored server-side.
     * Create an API key
     */
    async createApiKeyRaw(requestParameters: CreateApiKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedApiKey>> {
        if (requestParameters['createApiKeyRequest'] == null) {
            throw new runtime.RequiredError(
                'createApiKeyRequest',
                'Required parameter "createApiKeyRequest" was null or undefined when calling createApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/api-keys`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateApiKeyRequestToJSON(requestParameters['createApiKeyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatedApiKeyFromJSON(jsonValue));
    }

    /**
     * Returns the plaintext key exactly once. Only a hash is stored server-side.
     * Create an API key
     */
    async createApiKey(requestParameters: CreateApiKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedApiKey> {
        const response = await this.createApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the current user\'s API keys
     */
    async listApiKeysRaw(requestParameters: ListApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListApiKeys200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/api-keys`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListApiKeys200ResponseFromJSON(jsonValue));
    }

    /**
     * List the current user\'s API keys
     */
    async listApiKeys(requestParameters: ListApiKeysRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListApiKeys200Response> {
        const response = await this.listApiKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all API keys in the company (admin/owner only)
     */
    async listCompanyApiKeysRaw(requestParameters: ListCompanyApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCompanyApiKeys200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/api-keys/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCompanyApiKeys200ResponseFromJSON(jsonValue));
    }

    /**
     * List all API keys in the company (admin/owner only)
     */
    async listCompanyApiKeys(requestParameters: ListCompanyApiKeysRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCompanyApiKeys200Response> {
        const response = await this.listCompanyApiKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Users revoke their own keys; company admins/owners can revoke any key in the company.
     * Revoke an API key
     */
    async revokeApiKeyRaw(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['apiKeyId'] == null) {
            throw new runtime.RequiredError(
                'apiKeyId',
                'Required parameter "apiKeyId" was null or undefined when calling revokeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/api-keys/{apiKeyId}`.replace(`{${"apiKeyId"}}`, encodeURIComponent(String(requestParameters['apiKeyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Users revoke their own keys; company admins/owners can revoke any key in the company.
     * Revoke an API key
     */
    async revokeApiKey(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeApiKeyRaw(requestParameters, initOverrides);
    }

}
